import styled from 'styled-components';

import TaskDueDate from 'containers/TaskDetails/components/TaskDueDate';
import TaskStatusChip from 'containers/TaskDetails/components/TaskStatusChip';

export const StyledTaskDueDate = styled(TaskDueDate)`
  font-size: 14px;
`;

export const StyledTaskChip = styled(TaskStatusChip)`
  font-size: 13px;
`;
